import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=23ba1372&scoped=true&"
import script from "./Attachments.vue?vue&type=script&lang=ts&"
export * from "./Attachments.vue?vue&type=script&lang=ts&"
import style0 from "./Attachments.vue?vue&type=style&index=0&id=23ba1372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba1372",
  null
  
)

export default component.exports